/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import Error from '../Error';

const InputField = ({ type, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div className={type}>
      <input
        type={type}
        className={`text-input ${type} ${
          meta.touched && meta.error ? 'error' : null
        }`}
        {...field}
        {...props}
      />
      {type === 'password' ? <span className="password-toggle" /> : null}
      {meta.touched && meta.error ? <Error error={meta.error} /> : null}
      <style jsx>
        {`
          div {
            overflow: hidden;
            margin-bottom: 16px;
          }
          .hidden {
            display: none;
          }
          input {
            border: 1px solid #242424;
            padding: 14px 16px;
            color: rgba(228, 228, 2280.75);
            width: 100%;
            background: #141414;
            border-radius: 4px;

            font-family: 'Roboto-Medium';
            font-size: 13px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0em;
            text-align: left;

            padding: 14px 16px;
          }
          input:focus {
            outline: none;
          }
          input.error {
            border-color: rgb(255, 93, 93);
            border-width: 1px;
            background-color: rgba(255, 93, 93, 0.16);
          }
        `}
      </style>
    </div>
  );
};

InputField.propTypes = {
  type: PropTypes.string.isRequired,
};

export default InputField;
